import _ from 'lodash';
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import PackageHeader from '../components/PackageHeader';

@inject('packageStore')
@observer
export default class PackageBenefit extends Component {
  componentWillMount() {
    this.setPackageInfoInStore();
  }

  setPackageInfoInStore() {
    const {
      packageStore: {
        setPackageInfo:setPackageInfoInStore,
        setHistoryGroups:setHistoryGroupsInStore,
      },
      location,
    } = this.props;

    const pathname = location.pathname;
    const barcode = pathname.split('/')[2];

    setPackageInfoInStore(barcode);
    setHistoryGroupsInStore(barcode);
  }

  getStateStyle = (state) => {
    let stateClass = '';

    switch (state) {
      case 'A':
        stateClass = 'txt-used'; 
        break;
      case 'AR':
        stateClass = 'txt-using'; 
        break;
      case 'E':
        stateClass = 'txt-use'; 
        break;
      default:
        stateClass = 'txt-disabled'; 
    }
    return stateClass;
  }

  renderHistoryTickets = (tickets) => {
    if (_.isEmpty(tickets)) return;

    return _.map(tickets, (ticket, index) => {
      const {
        ticketNm,
        orderState,
        orderStateNm,
        usedCount,
        orderedCount,
      } = ticket;

      const stateClass = this.getStateStyle(orderState);

      return (
        <div className="ticket-package" key={ticketNm}>
          <h3 className="name-ticket">{ticketNm}</h3>
          <div className="cont-ticket">
            <span className={`txt-state ${stateClass}`}>{orderStateNm}</span>
            <span className="txt-count">| ({usedCount}/{orderedCount})</span>
          </div>
        </div>
      )
    });
  }

  renderHistoryList = (historyGroup, barcode) => {
    if (_.isEmpty(historyGroup)) return;

    return _.map(historyGroup, (history, index) => {
      const {
        groupName,
        tickets,
      } = history;

      return (
        <div 
          className="box-package"
          key={groupName}
        >
          <h3 className="name-package">{groupName}</h3>
          {this.renderHistoryTickets(tickets)}
        </div>
      )
    });
  }

  render() {
    const {
      packageStore: {
        barcode,
        packageInfo,
        historyGroups,
      },
    } = this.props;

    if (_.isEmpty(packageInfo)) return false;

    return (
      <div className="App Package">
        <PackageHeader
          tab="history"
        />
        <div className="App-container fade">
          <div className="group-packages">
            {this.renderHistoryList(historyGroups, barcode)}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/PackageHistory.jsx